<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.default_settings' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="card">
                                <div class="card-body">
                                    <fieldset [disabled]="mode == 'view'">
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.event_date' | transloco }}</label>
                                            <div class="col-md-3">
                                                <wj-combo-box style="width:100%;" [itemsSource]="optionAuction" [(ngModel)]="preference.auction" [displayMemberPath]="'display'" [isRequired]="false"></wj-combo-box>
                                            </div>
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.seller' | transloco }}</label>
                                            <div class="col-md-3">
                                                <wj-auto-complete #sellerAutoComplete [(ngModel)]="preference.seller" style="width:100%;" [placeholder]="'admin.seller' | transloco" [displayMemberPath]="'memberName'" [itemsSourceFunction]="getSeller" [isRequired]="false"></wj-auto-complete>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.item_category' | transloco }}</label>
                                            <div class="col-md-3">
                                                <select class="form-control" [(ngModel)]="preference.category">
                                                    <option *ngFor="let item of optionCategory"
                                                            [value]="item.value">{{ item.value }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.auction_result' | transloco }}</label>
                                            <div class="col-md-3">
                                                <select class="form-control" [(ngModel)]="preference.auctionResult">
                                                    <option *ngFor="let item of optionAuctionResult" [value]="item.value">{{ item.value }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.item_name' | transloco }}</label>
                                            <div class="col-md-9">
                                                <input type="text" [(ngModel)]="preference.name" class="form-control" [placeholder]="'admin.item_name' | transloco">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.item_description' | transloco }}</label>
                                            <div class="col-md-9">
                                                <textarea type="text" [(ngModel)]="preference.description" class="form-control" [placeholder]="'admin.item_description' | transloco"></textarea>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.quantity' | transloco }}</label>
                                            <div class="col-md-3">
                                                <input type="number" [(ngModel)]="preference.quantity" class="form-control" [placeholder]="'admin.quantity' | transloco">
                                            </div>
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.unit' | transloco }}</label>
                                            <div class="col-md-3">
                                                <select class="form-control" [(ngModel)]="preference.unit">
                                                    <option *ngFor="let item of optionUnit" [value]="item.value">{{ item.value }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.minimum_price' | transloco }}</label>
                                            <div class="col-md-3">
                                                <input type="number" [(ngModel)]="preference.minimumPrice" class="form-control" [placeholder]="'admin.minimum_price' | transloco">
                                            </div>
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.start_price' | transloco }}</label>
                                            <div class="col-md-3">
                                                <input type="number" [(ngModel)]="preference.startPrice" class="form-control" [placeholder]="'admin.start_price' | transloco">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.seller_fee_rate' | transloco }}</label>
                                            <div class="col-md-3">
                                                <input type="number" [(ngModel)]="preference.sellerCharge" class="form-control" [placeholder]="'admin.seller_fee_rate' | transloco">
                                            </div>
                                            <label class="col-md-3 form-control-label d-none d-lg-block">{{ 'admin.buyer_fee_rate' | transloco }}</label>
                                            <div class="col-md-3">
                                                <input type="number" [(ngModel)]="preference.buyerCharge" class="form-control" [placeholder]="'admin.buyer_fee_rate' | transloco">
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div *ngIf="mode == 'view'" class="card-footer">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <button (click)="editPreference()" class="btn btn-primary btn-block">{{ 'common.edit' | transloco }}</button>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="mode == 'edit'" class="card-footer">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <button (click)="savePreference()" class="btn btn-primary btn-block">{{ 'common.save' | transloco }}</button>
                                        </div>
                                        <div class="col-md-6">
                                            <button (click)="cancelPreference()" class="btn btn-danger btn-block">{{ 'common.cancel' | transloco }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

